/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID} from '../../configs/const';
import { DOMAINDISPLAY } from '../../configs/apkFileName';

let oid = OPERATOR_ID.toLowerCase()


export default class CookiePolicy extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    render() {
        return (
            <>
           <section className='sportbook-livecasino'>                
                <div className="subpage-head1">
                    <div className="subpage-head1__image">
                        <img alt="Offers Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner.jpg"} />
                    </div> 
                    <div className="subpage-head1__content">
                        <h1 className="subpage-head1__title">Cookie Policy</h1>
                    </div>
                </div>
            </section>
                <div className="container mt-5">
                    <div className="row">
                       <div className='col-12'>
                            {/* <p className='section-head__title text-center text-uppercase termsbox'>Privacy Policy</p> */}
                        </div>
                        <div className='col-12 loginrulesbox'>
                        <p className='loginrulestitle'>To ensure that this website works properly and smoothly and, to ensure that we always
provide the most relevant services to you, we may place small text files (‘cookies’) onto
your device. Please keep reading for more information about our cookies and how you
can be in control of them</p>

<p className='loginrulestitle font-bold'>What is a cookie?</p>
<p className='loginrulestitle font-bold'>Cookies and other similar technologies are small text files containing a small amount of
information that are downloaded onto or stored within your device when you visit our
website or use our app.
<br></br>
There are 2 main types of cookies:
</p>
<p className='loginrulestitle'>Session cookies</p>
<ul className="rulesul">
    <li>are downloaded to your device temporarily for the period that you browse a
    particular website. When you close your browser these cookies are
    permanently lost. An example of a session cookie is when you navigate from
    one page of the site to another page of the site during the same visit, you do
    not need to input your credentials each time.
    </li>
</ul>
<p className='loginrulestitle'>Persistent cookies</p>
<ul className="rulesul">
    <li>aka a ‘stored cookie’ is stored on your hard drive and has a pre-set expiration
date. These cookies may remember things like you choosing to view {DOMAINDISPLAY.name} in
Spanish, so when you revisit the site at a later date, it is automatically in
Spanish for you.</li>
</ul>

<p className='loginrulestitle'>Cookies can be set by us (first party cookies) or by another company (third party cookies)</p>
<p className='loginrulestitle'>First party cookies</p>
<ul className="rulesul">
    <li>These are set and handled directly by {DOMAINDISPLAY.name}, they cannot be read or accessed by another website. For example cookies to help maintain your login session, or to launch the banking section of the website.</li>
</ul>
<p className='loginrulestitle'>Third party cookies</p>
<ul className="rulesul">
    <li>These are cookies that have been set by approved third parties, for example to
help give us data on the amount of website traffic we get, or to initiate fraud
checks.</li>
</ul>

<p className='loginrulestitle font-bold'>What cookies do we use?</p>
<p className='loginrulestitle'>We categorise our cookies into 4 main types, please see more detail below:</p>

<p className='loginrulestitle font-bold'>Essential Cookies</p>
<p className='loginrulestitle font-bold'>Why?</p>
<p className='loginrulestitle'>To enable you to navigate through our site and use its features. These cookies are used
to provide you content from the site and to provide you with the products and services
that you expect from using our site.</p>
<p className='loginrulestitle font-bold'>Examples:</p>
<ul className="rulesul">
    <li>To authenticate your details.</li>
    <li>To help keep your information secure.</li>
    <li>For fraud and money laundering checks.</li>
    <li>If you log into the website, these cookies ensure you stay logged in.</li>
    <li>These cookies let us know what device you are using so we can give you the
best version of the site that suits your device.</li>
    <li>Store your preferred language.</li>
    <li>To authenticate you when launching a game.</li>
</ul>

<p className='loginrulestitle font-bold'>More information:</p>
<p className='loginrulestitle'>These cookies include both session and persistent cookies. They can also be set by us
or by approved third parties. Please note that if essential cookies are disabled you may
not be able to use the site.</p>
<p className='loginrulestitle font-bold'>Functional cookies</p>
<p className='loginrulestitle font-bold'>Why?</p>
<p className='loginrulestitle'>These cookies are used to ensure that certain features work properly and to customise
the content of the website based on choices you have made, they support the
performance of our site and ensure that you are able to keep playing the games you love
and accessing all our features</p>
<p className='loginrulestitle font-bold'>Examples:</p>
<ul className="rulesul">
    <li>Remember your username and language choice.</li>
    <li>Support the ease of transaction, wagering and payment loading within your
logged in account.
</li>
    <li>to help provide certain features such as live chat sessions.</li>
    <li>to remember that if you went on {DOMAINDISPLAY.name} Sports last time, you will go straight
back there rather than to {DOMAINDISPLAY.name} Casino.
</li>
    <li>if you prefer to see decimal odds over fractional, it will remember this for when
you use the site.</li>
</ul>

<p className='loginrulestitle font-bold'>More information:</p>
<p className='loginrulestitle'>These are first party cookies. These are set and handled directly by {DOMAINDISPLAY.name}, they cannot
be read or accessed by another website. Functional cookies can be either session or
persistent cookies.</p>

<p className='loginrulestitle font-bold'>Performance cookies</p>
<p className='loginrulestitle font-bold'>Why?</p>
<p className='loginrulestitle'>To enable us to collect data for statistical purposes on how you and other visitors use the
{DOMAINDISPLAY.name} site. These cookies will also pick up if visitors get error messages from some
pages.
</p>

<p className='loginrulestitle font-bold'>Examples:</p>
<ul className="rulesul">
    <li>Gathering data about number of visits and visitors to the site</li>
    <li>Help us see how you are using our website</li>
    <li>To identify any performance issues</li>
</ul>

<p className='loginrulestitle font-bold'>More information:</p>
<p className='loginrulestitle'>These are first party and third party cookies. Approved third parties may help us analyse
this data to better improve the service that we offer our visitors. We use Google Analytics
cookies to help us track what pages our customers are visiting and which features of the
website are being used. These cookies are used to improve how a website works.</p>

<p className='loginrulestitle font-bold'>Targeting or advertising cookies and similar technologies</p>
<p className='loginrulestitle font-bold'>Why?</p>
<p className='loginrulestitle'>These are used to deliver adverts that are relevant to you and your interests. They limit
the number of times you may see adverts too. Cookies here also help us to measure the
effectiveness of our advertising campaigns.
</p>

<p className='loginrulestitle font-bold'>Examples:</p>
<ul className="rulesul">
    <li>To provide us with information on your visit so that we can present you with
adverts that you may be interested in.</li>
    <li>To perform site retargeting. A retargeting pixel (a tiny unit of code) on our
webpage that leaves a cookie in the user’s browser, helps us decide whether
to display (or not to display) a relevant advert to you when you visit certain
websites within the retargeting network (e.g. Google Display Network).
</li>
    <li>To collect information about your {DOMAINDISPLAY.name} browsing experience so we can
advertise around contextually relevant content for you.
</li>
    <li>To collect information around your advertising experience with us. We want to
make sure we don’t advertise irrelevant adverts to you and keep the {DOMAINDISPLAY.name}
experience as seamless as possible.</li>
</ul>


<p className='loginrulestitle font-bold'>More information:</p>
<p className='loginrulestitle'>These cookies are placed by us and by carefully approved third parties. For social
marketing targeting we work with such companies as Facebook and Twitter to provide
you with bespoke advertisements that suit your preferences. To opt out, please see ‘How
can I control my cookies</p>

<p className='loginrulestitle font-bold'>How can I control my cookies?</p>
<p className='loginrulestitle'>At any time you can amend your browser settings to block some or all cookies from
{DOMAINDISPLAY.name}. However, if you block cookies from {DOMAINDISPLAY.name} some or all the website's functions
may not perform as intended. For example, you may not actually be able to place any
bets.
</p>

<p className='loginrulestitle'>You can use your browser to:</p>
<ul className="rulesul">
    <li>Delete all cookies</li>
    <li>Block all cookies</li>
    <li>Allow all cookies</li>
    <li>Block third party cookies when you close the browser</li>
    <li>Clear all cookies</li>
</ul>

<p className='loginrulestitle'>For more information on how to control your cookies on your chosen browser, please see
below:</p>

<p className='loginrulestitle'>Microsoft edge - </p>
<p className='loginrulestitle font-bold'><a href="https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy">https://privacy.microsoft.com/en-us/windows-10-microsoft-edge-and-privacy</a></p>

<p className='loginrulestitle'>Internet Explorer - </p>
<p className='loginrulestitle font-bold'><a href="https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-ma
nage-cookies
">https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-ma
nage-cookies
</a></p>

<p className='loginrulestitle'>Chrome - </p>
<p className='loginrulestitle font-bold'><a href="https://support.google.com/chrome/answer/95647?hl=en-GB">https://support.google.com/chrome/answer/95647?hl=en-GB</a></p>


<p className='loginrulestitle'>Firefox -</p>
<p className='loginrulestitle font-bold'><a href="https://support.mozilla.org/en-US/kb/delete-browsing-search-download-history-firefox">https://support.mozilla.org/en-US/kb/delete-browsing-search-download-history-firefox</a></p>


<p className='loginrulestitle'>Safari Mobile -  </p>
<p className='loginrulestitle font-bold'><a href="https://support.apple.com/en-gb/HT201265">https://support.apple.com/en-gb/HT201265</a></p>


<p className='loginrulestitle'>Safari Desktop -  </p>
<p className='loginrulestitle font-bold'><a href="https://support.apple.com/en-gb/guide/safari/manage-cookies-and-website-data-sfri11471/mac">https://support.apple.com/en-gb/guide/safari/manage-cookies-and-website-data-sfri11471/mac</a></p>


<p className='loginrulestitle'>If you would like further information on cookies please see <span className='font-bold'>Allaboutcookies.org</span> </p>

<p className='loginrulestitle'>For targeted social marketing you can also easily control the adverts by going to the
privacy settings on each. To control these technologies on social sites, please use the
following links:
</p>

<p className='loginrulestitle'>Facebook -  </p>
<p className='loginrulestitle font-bold'><a href="https://www.facebook.com/ads/preferences/edit/">https://www.facebook.com/ads/preferences/edit/</a></p>                  

<p className='loginrulestitle'>Twitter -  </p>
<p className='loginrulestitle font-bold'><a href="https://help.twitter.com/en/managing-your-account/connect-or-revoke-access-to-third-party-apps">https://help.twitter.com/en/managing-your-account/connect-or-revoke-access-to-third-party-apps</a></p>                  

<p className='loginrulestitle'>Snapchat -  </p>
<p className='loginrulestitle font-bold'><a href="https://support.snapchat.com/en-US/a/privacy-settings2">https://support.snapchat.com/en-US/a/privacy-settings2</a></p>   

<p className='loginrulestitle'>Instagram -  </p>
<p className='loginrulestitle font-bold'><a href="https://help.instagram.com/">https://help.instagram.com/</a></p>  
                    
                  
                    


                                
                                    
                                    </div>
                        </div>
                </div>
                
            </>
        )
    }
}
